import $ from 'jquery';

$.formatCurrency = function (price, currency) {
  return [$.formatNumber(price, 2), '&nbsp;', currency || '&euro;'].join('');
};
